import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider as ReduxProvider } from "react-redux";
import { Store, persistor } from "src/redux/Store";
import { AuthProvider } from "./auth/AuthProvider";
import { PersistGate } from "redux-persist/lib/integration/react";
import { registerLicense } from "@syncfusion/ej2-base";

// Registering Syncfusion license key
registerLicense(
  "Ngo9BigBOggjHTQxAR8/V1NHaF5cXmVCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWX1fdnRQR2hYV0N/XUM="
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ReduxProvider store={Store}>
    <AuthProvider>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </AuthProvider>
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals( ))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
